module.exports = __webpack_public_path__ + "img/jl.ac38cace.jpg";